export default __webpack_public_path__ + "static/media/Christian-Lagueux-7b.02c42ba5.jpg";